import type { PicotSpice } from "../types/api";

function slotText(value: unknown): string | undefined {
  if (value == null) return undefined;
  const text = String(value).trim();
  return text.length ? text : undefined;
}

function applySlotMap(
  raw: Record<string, unknown>,
  mappings: ReadonlyArray<readonly [string, keyof PicotSpice]>,
): PicotSpice {
  const out: PicotSpice = {};
  for (const [sourceKey, slotKey] of mappings) {
    if (out[slotKey]) continue;
    const text = slotText(raw[sourceKey]);
    if (text) out[slotKey] = text;
  }
  return out;
}

const PICOT_MAPPINGS = [
  ["population", "P"],
  ["intervention", "I"],
  ["comparison", "C"],
  ["outcome", "O"],
  ["time", "T"],
  ["timeframe", "T"],
  ["P", "P"],
  ["I", "I"],
  ["C", "C"],
  ["O", "O"],
  ["T", "T"],
] as const satisfies ReadonlyArray<readonly [string, keyof PicotSpice]>;

const SPICE_MAPPINGS = [
  ["setting", "S"],
  ["perspective", "P"],
  ["intervention", "I"],
  ["comparison", "C"],
  ["evaluation", "E"],
  ["S", "S"],
  ["P", "P"],
  ["I", "I"],
  ["C", "C"],
  ["E", "E"],
] as const satisfies ReadonlyArray<readonly [string, keyof PicotSpice]>;

/** Map backend rewriter keys (population, intervention, …) to UI slot keys (P, I, …). */
export function normalizePicot(raw: unknown): PicotSpice | null {
  if (!raw || typeof raw !== "object") return null;
  return applySlotMap(raw as Record<string, unknown>, PICOT_MAPPINGS);
}

/** Map backend rewriter keys (setting, perspective, …) to UI slot keys (S, P, …). */
export function normalizeSpice(raw: unknown): PicotSpice | null {
  if (!raw || typeof raw !== "object") return null;
  return applySlotMap(raw as Record<string, unknown>, SPICE_MAPPINGS);
}
